var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGrayOtherIconSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0v4l4-4H0Zm12 0 4 4V0h-4Zm4 16v-4l-4 4h4ZM0 16h4l-4-4v4Zm15-8c0-3.87-3.13-7-7-7S1 4.13 1 8s3.13 7 7 7 7-3.13 7-7Zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z",
  fill: "#000",
  fillOpacity: 0.2
})));

export { SvgGrayOtherIconSmall as ReactComponent };
export default __webpack_public_path__ + "f3e074dfc3c6f68bbf0b112584db3964.svg";